import { formatDate, parseCurrencyToNumber } from '../../../helpers'
import { ListCategoryDoc } from '../../../redux-toolkits/categories/categories.type'
import { CreateEvent } from '../../../redux-toolkits/events/events.type'
import { Tag } from '../../../redux-toolkits/products/products.type'
import { StrippedVendor } from '../../../redux-toolkits/vendors/vendors.types'

export type EventFormValues = CreateEvent & {
  isTiered: boolean
  categories: ListCategoryDoc[]
  tags_: Tag[]
  vendor: StrippedVendor
}

const toPricingPayload = (vals: EventFormValues) => ({
  price: vals.isTiered ? undefined : parseCurrencyToNumber(vals.price),
  ...(!vals.isTiered && {
    isMarkupEnabled: vals.isMarkupEnabled,
    ...(vals.isMarkupEnabled && {
      markupValue: Number(vals.markupValue),
    }),
  }),
  inStockQuantity: vals.isTiered
    ? undefined
    : parseCurrencyToNumber(vals.inStockQuantity),
})

const toTicketSettingsPayload = (
  settings: EventFormValues['eventTicketSettings'],
): CreateEvent['eventTicketSettings'] => ({
  eventDate: formatDate(settings.eventDate, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]', {
    mode: 'toUtc',
  }),
  // Edit replaces the settings as a whole, so always send the venue centre.
  venueCentre: settings.venueCentre ?? null,
  venue: settings.venue,
  city: settings.city,
  address: settings.address,
  minQuantityPerPurchase: parseCurrencyToNumber(
    settings.minQuantityPerPurchase,
  ),
  maxQuantityPerPurchase: parseCurrencyToNumber(
    settings.maxQuantityPerPurchase,
  ),
  tiers: settings.tiers,
})

export const toEventPayload = (vals: EventFormValues): CreateEvent => ({
  name: vals.name,
  description: vals.description,
  categoryId: vals.categoryId,
  images: vals.images,
  vendorId: vals.vendorId,
  tags: vals.tags,
  trackQuantity: vals.trackQuantity,
  isActive: vals?.isActive ?? false,
  ...toPricingPayload(vals),
  eventTicketSettings: toTicketSettingsPayload(vals.eventTicketSettings),
})
